// @flow
import * as React from 'react';

import { Container } from './styles';
import { LoadingIndicator } from '~/components/widgets';
import type { Props } from './types';

const ANIMATION_DURATION = 1440;

export default class LoginIndicator extends React.Component<Props, void> {
    componentDidMount() {
        const { isLoggedIn, startLoginAnimation, stopLoginAnimation } = this.props;

        if (isLoggedIn) {
            startLoginAnimation();
            setTimeout(() => {
                stopLoginAnimation();
            }, ANIMATION_DURATION);
        }
    }

    render() {
        const { isLoading, showLoginAnimation, children } = this.props;
        return (
            <Container>
                <LoadingIndicator isLoading={isLoading || showLoginAnimation}>{children}</LoadingIndicator>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/indicators/login/component.js